import React from 'react';

export function NewTag() {
  return (
    <div className='flex justify-center v2-bg-yellow-500 w-[75px] h-[75px] absolute transform z-[5] -rotate-45 -translate-y-11 -translate-x-11'>
      <span className='inline-block self-end font-bold text-[10px] v2-text-white p-0.5'>
        New
      </span>
    </div>
  );
}
